var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBanknote = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none",
    viewBox: "0 0 14 14",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#75777B",
    d: "M.6992 3.8607v6.7769c0 .3937.221.7656.5906.9034 1.9032.711 3.8063.2253 5.7094-.2603 1.7456-.444 3.4913-.8903 5.2347-.4134.5031.1378 1.0653-.2078 1.0653-.7306V3.362c0-.3938-.2209-.7656-.5906-.9035-1.9031-.7109-3.8063-.2253-5.7094.2604-1.7456.444-3.4912.888-5.2347.4112-.5053-.1378-1.0653.2078-1.0653.7306m6.3 5.239c-.9669 0-1.75-.9405-1.75-2.1 0-1.1593.7831-2.1 1.75-2.1s1.75.9407 1.75 2.1c0 1.1595-.7831 2.1-1.75 2.1m-4.9 0c.7722 0 1.4.6279 1.4 1.4001h-1.4zm1.4-4.55c0 .7723-.6278 1.4-1.4 1.4v-1.4zm8.4 3.5v1.4h-1.4c0-.7721.6278-1.4 1.4-1.4m-1.4-4.55h1.4v1.4c-.7722 0-1.4-.6277-1.4-1.4"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBanknote);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/banknote.e1e81a99f300f4be510810d11602e865.svg";